import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { ADD_EMAIL_TEMPLATE } from "utils/api/graphql/mutations/email";
import { GET_EMAIL_TEMPLATES } from "utils/api/graphql/queries/emailTemplate";
import { SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);

  const [addEmailTemplate] = useMutation(ADD_EMAIL_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_EMAIL_TEMPLATES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);
    },
  });

  const onSubmit = (data) => {
    return addEmailTemplate({
      variables: {
        data: { id, ...data },
      },
    });
  };

  return <View onSubmit={onSubmit} cancel={cancel} />;
};

export default Create;
